<template>
  <div class="code-bg" @click.stop>
    <img class="close-icon" src="~/assets/imgs/detail_close.png" @click="close" />
    <div class="title">请输入验证码</div>
    <div class="content">
      <span>验证码已发送至：{{ props.phoneCodeParams.cmccMobile }}</span>
      <input ref="inputRef" v-model="inputVal" type="text" placeholder="请输入验证码" />
    </div>
    <div class="repost" v-if="times === 0" @click="postAgain">重新发送验证码</div>
    <div class="repost" v-if="times > 0">{{ times }}s后可重发</div>
    <div class="footer">
      <div class="confirm" @click="confirm" v-if="inputVal.length > 0">确定</div>
      <div style="background: #ccc" class="confirm" v-else>确定</div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { defineEmits, defineProps } from "vue";
import { surecode } from "~/business/alova/methods/goodsPageApi.ts";
import { useRequest } from "alova";

const emit = defineEmits(["close", "failPrice", "exchangeRes"]);
const props = defineProps<{
  phoneCodeParams: {};
}>();
const inputVal = ref("");
const ismobilecodeback = ref(false);
const inputRef = ref(null);
onMounted(() => {
  inputRef.value.focus();
});
/**
 * @description 验证码提交
 * @return {void}
 */
const confirm = () => {
  if (ismobilecodeback.value) return;
  ismobilecodeback.value = true;
  const params = {
    machinetype: "H5",
    mobileSmsCode: inputVal.value,
    orderNo: props.phoneCodeParams.mobileOrderNo
  };

  const { data, onSuccess ,onError} = useRequest(()=>{return surecode(params)})
  onSuccess((res)=>{
    ismobilecodeback.value = false;
    if (res?.data?.code === 200) {
      // getprizesuccess(res.data);
      emit("exchangeRes", res?.data?.data);
    } else {
      emit("failPrice", res?.data?.code, res?.data?.data);
    }
    close();
  })
  onError((e)=>{
    ismobilecodeback.value = false;
    emit("failPrice", e?.data?.code, e?.data);
    close();
  })
};
/**
 * @description 关闭弹窗
 * @return {void}
 */
const close = () => {
  emit("close");
};
const times = ref(60);
/**
 * @description 重新倒计时发送验证码
 * @return {void}
 */
const postAgain = () => {
  times.value = 60;
  let timer = setInterval(() => {
    times.value--;
    if (times.value === 0) {
      clearInterval(timer);
    }
  }, 1000);
};
onMounted(() => {
  postAgain();
});
</script>
<style scoped lang="scss">
.code-bg {
  width: 13.25rem;
  background: #fff;
  position: relative;
  border-radius: 0.5rem;

  .close-icon {
    width: 0.9rem;
    height: 0.9rem;
    position: absolute;
    top: 0.6rem;
    right: 0.6rem;
  }

  .title {
    margin: 0.65rem 0 1.24rem 0;
    text-align: center;
    font-size: 0.685rem;
    font-weight: 600;
  }

  .content-error {
    color: #000;
    font-size: 0.685rem;
    font-weight: 600;
    text-align: center;
  }

  .repost {
    font-size: 0.6rem;
    color: #ff7210;
    text-align: center;
    margin-top: 1rem;
  }

  .content {
    color: #000;
    font-size: 0.54rem;
    padding: 0 1rem;

    input {
      height: 1.7rem;
      width: calc(13.25rem - 2rem);
      padding: 0 0.5rem;
      margin-top: 1rem;
      border-radius: 0.5rem;
      line-height: 0.68rem;
      background: #f5f5f5;
      margin-right: 0.1rem;
      font-size: 0.58rem;
      border: none; /* 隐藏边框 */
      outline: none; /* 隐藏默认的焦点边框 */
      caret-color: #000; /* 设置竖线的颜色 */
    }

    input::placeholder {
      font-size: 0.7rem;
    }

    input::focus {
      border: none; /* 保持边框隐藏 */
      outline: none; /* 保持默认的焦点边框隐藏 */
      box-shadow: none; /* 防止一些浏览器添加阴影 */
    }
  }

  .footer {
    font-size: 0.7rem;
    display: flex;
    justify-content: center;

    .confirm {
      height: 1.68rem;
      line-height: 1.68rem;
      width: 50%;
      background: #ff7210;
      color: #fff;
      text-align: center;
      border-radius: 1rem;
      margin: 1rem 0 1rem 0;
    }
  }
}
</style>
